import HomeAgence from "../components/Home/HomeAgence";
import PhotoVideo from "../components/Home/PhotoVideo";
import ProjetsHome from "../components/Home/ProjetsHome";
import FormHome from "../components/FormHome";
import SliderHome from "../components/SliderHome";
import Avis from "../components/Home/Avis";
import React, {useEffect, useRef, useState} from "react";
import {API_URL} from '../config';


function Home() {

    console.log(API_URL)
    const [headerVideo, setHeaderVideo] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const modalRef = useRef(null);

    useEffect(() => {
        fetch(`${API_URL}/header-video`)
            .then((res) => res.json())
            .then((data) => {
                if (data.video) setHeaderVideo(data.video);
            })
            .catch((err) => console.error(err));
    }, []);

    function getEmbedUrl(url) {
        const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
        if (vimeoMatch) return 'https://player.vimeo.com/video/' + vimeoMatch[1] + '?autoplay=1';

        const youtubeMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/);
        if (youtubeMatch) return 'https://www.youtube.com/embed/' + youtubeMatch[1] + '?autoplay=1';

        return url;
    }

    function getBackgroundEmbedUrl(url) {
        const vimeoMatch = url.match(/vimeo\.com\/(\d+)/);
        if (vimeoMatch) {
            return `https://player.vimeo.com/video/${vimeoMatch[1]}?autoplay=1&muted=1&loop=1&background=1`;
        }

        const youtubeMatch = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([a-zA-Z0-9_-]+)/);
        if (youtubeMatch) {
            const id = youtubeMatch[1];
            return `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&loop=1&playlist=${id}&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1`;
        }

        return null;
    }

    const handleProjectClick = () => {
        setShowModal(true);
    };

    const handleCloseModal = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            setShowModal(false);
        }
    };

    return(
        <>
            <div className="container-home-header h-screen flex justify-center items-center flex-col" style={{ position: 'relative', overflow: 'hidden' }}>

                {/* Vidéo en background */}
                {headerVideo && getBackgroundEmbedUrl(headerVideo.url) && (
                    <div style={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: '177.78vh',
                        minWidth: '100%',
                        height: '56.25vw',
                        minHeight: '100%',
                        zIndex: 0,
                        pointerEvents: 'none',
                    }}>
                        <iframe
                            src={getBackgroundEmbedUrl(headerVideo.url)}
                            style={{ width: '100%', height: '100%', border: 'none' }}
                            allow="autoplay; fullscreen"
                            allowFullScreen
                        />
                    </div>
                )}

                {/* Overlay sombre */}
                {headerVideo && (
                    <div style={{
                        position: 'absolute', inset: 0,
                        background: 'rgba(0,0,0,0.45)',
                        zIndex: 1,
                    }} />
                )}

                {/* Contenu */}
                <div style={{ position: 'relative', zIndex: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <h1 className="xl:text-8xl font-bold min-[320px]:text-f-40">Focus Production</h1>
                    <hn className="xl:text-5xl min-[320px]:text-xl">Capturer <span>l'instant</span>, partager <span>l'émotion</span></hn>
                    {headerVideo && (
                        <a className="mt-32 text-2xl btn-arrow -ml-11" onClick={handleProjectClick}>Voir le showreel</a>
                    )}
                </div>

                {/* Modal showreel */}
                <div className={`showreel-modal ${showModal ? 'open' : ''}`} onClick={handleCloseModal} style={{ zIndex: 10 }}>
                    <div className="showreel-modal-content" ref={modalRef}>
                        <button onClick={() => setShowModal(false)} className="showreel-modal-close"></button>
                        {headerVideo && showModal && (
                            <iframe
                                src={getEmbedUrl(headerVideo.url)}
                                width="100%"
                                height="100%"
                                frameBorder="0"
                                allow="autoplay; fullscreen"
                                allowFullScreen
                                style={{ aspectRatio: '16/9', borderRadius: '10px' }}
                            />
                        )}
                    </div>
                </div>

            </div>

            <HomeAgence/>
            <PhotoVideo/>
            <SliderHome/>
            <ProjetsHome/>
            <div className="pb-32">
                <Avis/>
            </div>
            <FormHome/>
        </>
    )
}

export default Home